(function() {
  'use strict';

  angular.module('app').factory('RECaptchaService', POSService);

  POSService.$inject = ['$rootScope', 'API'];

  function POSService($rootScope, API) {
    var service = {};

    $rootScope.initRecaptcha = function(siteKey) {
      return new Promise(function(resolve, reject) {
        window['gRecaptchaLoaded'] = function() {
          isLoaded = true;
          resolve('success');
        };

        if (isLoaded || ('grecaptcha' in window)) {
          resolve('success');
          return;
        } else {
          var script = document.createElement('script');
          script.innerHTML = '';
          script.src = baseUrl + '?onload=gRecaptchaLoaded&render=' + siteKey;
          script.id = 'recapthcha-' + scriptId;
          script.async = true;
          script.defer = true;
          script.onload = function() {
            // resolve('success');
          };
          script.onerror = function() {
            reject('error');
          };
          document.head.appendChild(script);
        }

      });
    };

    var baseUrl = 'https://www.google.com/recaptcha/api.js';
    var isLoaded = false;
    var scriptId = +(new Date());

    service.getToken = function(siteKey, action) {
      return new Promise(function(resolve) {
        var init = $rootScope.initRecaptcha(siteKey).then(function() {
          window['grecaptcha'].ready(function() {
            if (!!action) {
              window['grecaptcha'].execute(siteKey, {action: action}).then(resolve);
            } else {
              window['grecaptcha'].execute(siteKey).then(resolve);
            }
          });
        });
      });
    };

    return service;
  }
})();
